import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import {
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import { Tooltip } from '@mui/material';

import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchDataActive, fetchData, postData, updateData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function ParentGroupIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteManufacture, setDeleteManufacture] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    //const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, clubId, userId, branchId, permissions, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState("");
    //Create Constants---------------------
    const [isSubmit, setIsSubmit] = useState(false);
    const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
    const [assetname, setName] = useState("");

    const [depreciation, setDepreciation] = useState("");


    const [selectedValue, setSelectedValue] = useState(1);
    //-------------------------------------------for edit-------------------
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false); // For editing
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null); // Holds the person data when editing
    const [parentGroupOptions, setParentGroupOptions] = useState([]);
    const [selectedgroup, setselectedgroup] = useState("");

    //------------------
    const [isBalanceSheetHead, setIsBalanceSheetHead] = useState(true);//else P&L Head
    const [head, setHead] = useState("");
    const [amount, setAmount] = useState("");
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        // fetchParentData();
        //  inputRef.current.focus();
    }, [isAuthenticated, clubId, branchId, token, logout]);



    const fetchtableData = async () => {
        fetchData('ParentGroupApi', `/${clubId}/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    //setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Head Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const handleDelete = async () => {
        deleteData('ParentGroupApi', `${deleteManufacture}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteManufacture(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (manuId) => {
        activateData('ParentGroupApi', `${manuId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (manuId) => {
        setDeleteManufacture(manuId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteManufacture(null);
        setConfirmDialogOpen(false);
    };


    //Create Section----------------------
    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData(e);

    }

    const submitData = async (e) => {
        e.preventDefault();

        // Validation
        if (!head || !amount) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            return;
        }

        // Convert string to number
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount)) {
            setErrorMessage("Amount must be a valid number.");
            return;
        }

        const heads = {
            Head: head,
            Amount: parsedAmount,
            CreatedBy: userId || "",
            CreatedDate: new Date().toISOString(),
            ClubId: clubId || "",
            BranchId: branchId || "",
            IsActive: true,
            IsBalanceHead: isBalanceSheetHead,

        };

        try {
            const response = await postData('ParentGroupApi', heads, token);
            console.log('Head Created successfully:', response);
            setSuccessMessage("Head Created successfully!");
            setErrorMessage("");

            resetForm(); // Make sure this resets all state including `head`, `amount`, etc.
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

            window.location.reload();
        } catch (error) {
            console.error('Head Create error:', error);
            setErrorMessage("Error creating Head. Please try again.");
        }

        setIsModalOpenCreate(false);
    };



    const toggleModalCreate = () => {
        setIsModalOpenCreate(prev => !prev);

    };
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };


    //Edit-------------------------

    const toggleModalEdit = () => {
        setIsModalOpenEdit(prev => !prev);
        if (isModalOpenEdit) {
            resetForm(); // Only reset when modal is closing, not opening
            setEditData(null);
            setIsEditing(false);
        }
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
    };
    // Reset form fields
    const resetForm = () => {
        setName('');

        setDepreciation('');
    };

    const handleEdit = (Id) => {
        // Find the item from the existing list using the ID
        const selectedHead = data.find(item => item.Id === Id);

        if (!selectedHead) {
            console.error('Head not found in local data');
            return;
        }

        // Reset the fields
        setName('');
        setDepreciation('');

        // Set data directly from found item
        setEditData(selectedHead);
        setHead(selectedHead.Head);
        setAmount(selectedHead.Amount);
        setIsBalanceSheetHead(selectedHead.IsBalanceHead);
        setIsEditing(true);
        toggleModalEdit(); // Open the modal
    };


    const handleFormSubmitEdit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount)) {
            setErrorMessage("Amount must be a valid number.");
            return;
        }
        if (isEditing && editData) {
            const assets = {
                Id: editData.Id,
                Head: head,
                IsBalanceHead: isBalanceSheetHead,
                Amount: parsedAmount,
                UpdatedBy: userId || "",
                UpdatedDate: new Date(),
                ClubId: clubId || "",
                BranchId: branchId || "",
            };

            try {
                const response = await updateData('ParentGroupApi', editData.Id, assets, token);
                console.log('Record updated successfully:', response);
                setSuccessMessage("Record updated successfully!");
                toggleModalEdit(); // Close the modal
                setTimeout(() => {
                    setSuccessMessage(""); // Clear success message after a delay
                }, 3000);
                fetchtableData(); // Refresh the table data
            } catch (error) {
                console.error('Error updating record:', error);
            }
        }
    };

    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleParentGroupChange = (selectedOption) => {
        setselectedgroup(selectedOption); // Store the whole object
    };

    const sortedData = stableSort(filteredData, getComparator(order, orderBy));
    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '1.00%',
        marginRight: '8px',
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>



                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}>PARENT GROUP</h6>

                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '250px' : '140px',
                        height: '30px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginLeft: '10px'
                    }}
                />

                <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title="Create ASSET REGISTRATION"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#0e728c',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                },
                            },
                        }}
                    >
                        <Button
                            component={Link}
                            onClick={toggleModalCreate}
                            className="linkcolor"
                            style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}
                        >
                            CREATE
                        </Button>
                    </Tooltip>
                </div>


            </div>


            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>

                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Asset</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontWeight: 'bold', textAlign: 'right', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {filteredData.map((headdata, index) => (
                                <TableRow
                                    key={headdata.Id}
                                    className={headdata.IsActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd', // Alternate row background colors
                                    }}
                                >

                                    <TableCell sx={{ fontSize: '14px', padding: '2px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '2px' }}>{headdata.Head}</TableCell>
                                    <TableCell sx={{ padding: '2px' }}>{headdata.Amount}</TableCell>



                                    <TableCell sx={{ padding: '2px', textAlign: 'right' }}>

                                        <Link to="#" onClick={() => handleEdit(headdata.Id)}>
                                            <Tooltip title="Edit Head">
                                                <IconButton>
                                                    <EditIcon style={{ fontsize: '10px', color: 'blue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>

                                        <Tooltip title="Delete Head">
                                            <IconButton onClick={() => (headdata.IsActive ? openConfirmDialog(headdata.Id) : handleActivate(headdata.Id))}>
                                                {headdata.IsActive ? <DeleteIcon style={{ fontsize: '10px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '20px' }} />}
                                            </IconButton>
                                        </Tooltip>


                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                     <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            '& .MuiTablePagination-toolbar': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'nowrap', // Ensures everything stays in one line
                                minHeight: '40px', // Keeps a proper height
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: 0, // Fixes label misalignment
                            },
                            '& .MuiTablePagination-displayedRows': {
                                marginBottom: 0, // Fixes row count misalignment
                            },
                        }}
                    />

                </TableContainer>
            </div>


            {isModalOpenCreate && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '50%' }}>
                        <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center' }}>CREATE HEAD </h6>



                        <div>
                            <label className="block text-gray-700 font-medium mb-1">Select Head Type</label>
                            <div className="flex space-x-6">

                                <label className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        name="entityType"
                                        value="pandl"
                                        checked={!isBalanceSheetHead}
                                        onChange={() => setIsBalanceSheetHead(false)}
                                        className="form-radio text-green-500"
                                    />
                                    <span>P&L</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        name="entityType"
                                        value="balancehead"
                                        checked={isBalanceSheetHead}
                                        onChange={() => setIsBalanceSheetHead(true)}
                                        className="form-radio text-green-500"
                                    />
                                    <span>Balance Sheet</span>
                                </label>

                            </div>

                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label htmlFor="head">Head</label>
                                <input
                                    value={head}
                                    onChange={(e) => setHead(e.target.value)}
                                    type="text"
                                    placeholder="Enter Head"
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label htmlFor="amount">Amount</label>
                                <input
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    type="text"
                                    placeholder="Enter Amount"
                                    className="text-right"
                                />
                            </div>
                        </div>


                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>

                            <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                                Save
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalCreate}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            )}


            {isModalOpenEdit && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '40%' }}>
                        <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>EDIT ASSET</h6>
                        {/* Radio Buttons for selecting One Time or Monthly */}

                        <div>
                            <label className="block text-gray-700 font-medium mb-1">Select Head Type</label>
                            <div className="flex space-x-6">

                                <label className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        name="entityType"
                                        value="pandl"
                                        checked={!isBalanceSheetHead}
                                        onChange={() => setIsBalanceSheetHead(false)}
                                        className="form-radio text-green-500"
                                    />
                                    <span>P&L</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        name="entityType"
                                        value="balancehead"
                                        checked={isBalanceSheetHead}
                                        onChange={() => setIsBalanceSheetHead(true)}
                                        className="form-radio text-green-500"
                                    />
                                    <span>Balance Sheet</span>
                                </label>

                            </div>

                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label htmlFor="head">Head</label>
                                <input
                                    value={head}
                                    onChange={(e) => setHead(e.target.value)}
                                    type="text"
                                    placeholder="Enter Head"
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label htmlFor="amount">Amount</label>
                                <input
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    type="text"
                                    placeholder="Enter Amount"
                                    className="text-right"
                                />
                            </div>
                        </div>


                        {/* Action Buttons */}
                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            {/* <Button onClick={handleFormSubmitEdit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Update
                            </Button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }} onClick={toggleModalEdit}>
                                Cancel
                            </button> */}
                            <Button onClick={handleFormSubmitEdit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                                Update
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalEdit}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default ParentGroupIndex;




